import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import qs from "qs";

import { ApolloProvider } from "@apollo/react-hooks";
import ApolloClient, { InMemoryCache } from "apollo-boost";
import { persistCache } from "apollo-cache-persist";
import localForage from "localforage";
import config from "./config";

import Paperbase from "./sections/common/components/Paperbase";

const cache = new InMemoryCache({
  dataIdFromObject: o => (o._id ? `${o.__typename}:${o._id}` : null)
});

persistCache({
  cache,
  storage: localForage,
  maxSize: false
})
  .then(() => {
    let accessToken = qs.parse(window.location.hash).access_token;
    if (accessToken !== undefined) {
      localStorage.setItem("accessToken", accessToken);
    } else {
      accessToken = localStorage.getItem("accessToken");
    }

    const client = new ApolloClient({
      uri: config.appSync.endpoint,
      headers: {
        Authorization: `${accessToken}`
      },
      cache: cache,
      onError: ({ graphQLErrors, networkError }) => {
        if (
          graphQLErrors.length &&
          graphQLErrors[0].errorType === "UnauthorizedException"
        ) {
          window.location = config.auth.LOGIN_URL;
        }
        if (graphQLErrors)
          graphQLErrors.forEach(({ message, locations, path }) =>
            console.log(
              `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
            )
          );
        if (networkError) {
          console.log(`[Network error]: ${networkError}`);
        }
      }
    });

    const App = () => (
      <Router>
        <Switch>
          <Route path="/">
            <ApolloProvider client={client}>
              <Paperbase client={client} />
            </ApolloProvider>
          </Route>
        </Switch>
      </Router>
    );

    ReactDOM.render(<App />, document.querySelector("#app"));
  })
  .catch(err => {
    throw err;
  });



// WEBPACK FOOTER //
// ./src/index.js